import { render, staticRenderFns } from "./shopscode-add-or-update.vue?vue&type=template&id=effab7ba&scoped=true&"
import script from "./shopscode-add-or-update.vue?vue&type=script&lang=js&"
export * from "./shopscode-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./shopscode-add-or-update.vue?vue&type=style&index=0&id=effab7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effab7ba",
  null
  
)

export default component.exports